export const ageMethod = "age nearest";
export const gateway = "https://hwi-api.link.wawanesalife.com";
export const assets = "https://stable-assets.link.wawanesalife.com/brokers/hwi";
export const googleApiKey = "AIzaSyD8GAXLH7FxUmF13tfHgXVAU6fWk66UH3k";
export const appToken = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiJod2kiLCJuYW1lIjoiaHdpIiwiaWF0IjoxNzUwMjg4Njg1LCJleHAiOjE5MDgwNzY2ODV9.R1RL5wEJfuyHZWOeIFmDRy2lFYr5CBkn2TB-cBcQyJY";
export const brokerConfig = {
	enabled: "yes",
	authorized_nb: "no",
	authorized_mb: "no",
	authorized_pe: "no",
	authorized_yt: "no",
	authorized_sk: "yes",
	authorized_qc: "no",
	authorized_nt: "no",
	authorized_nu: "no",
	authorized_ns: "no",
	authorized_nl: "no",
	authorized_on: "no",
	authorized_ab: "yes",
	authorized_bc: "no",
	"split": '0.6'
};
export const brokerBranding = {
	"hwi.link.wawanesalife.com": {
		a: {
			environment: "stable",
			broker: "hwi",
			website: "https://harvardwestern.com/",
			broker_formatted_name: "Harvard Western Insurance",
			privacyLink: "https://harvardwestern.com/privacy-policy/",
			faq_text: "Frequently Asked Questions",
			layout: "modern",
			scope: "hwi#branding#hwi.link.wawanesalife.com#a",
			approve_company: "Link Platform",
			email: "info@harvardwestern.com",
			render_fake_email_button: "yes",
			g4: "GTM-P6HT43K",
			approve_user: "link_hwi",
			logoPosition: "menu",
			environment_id: "stable",
			brands: [
				"hwi.link.wawanesalife.com",
			],
			"maps": {
				"map3": [
					"4420 Albert Street",
					"Regina",
					"SK",
					"S4S 6B4",
				],
				"map2": [
					"464 McCarthy Blvd. N.",
					"Regina",
					"SK",
					"S4R 7M2",
				],
				"map1": [
					"3615 Quance Street East",
					"Regina",
					"SK",
					"S4V 3A4",
				],
				"map10": [
					"115 3rd St",
					"Dalmeny",
					"SK",
					"S0K 1E0",
				],
				"map7": [
					"109 Souris Street",
					"Yellow Grass",
					"SK",
					"S0G 5J0",
				],
				"map6": [
					"128 Main Street",
					"Milestone",
					"SK",
					"S0G 3L0",
				],
				"map5": [
					"5 Main Street",
					"Kronau",
					"SK",
					"S0G 2T0",
				],
				"map4": [
					"407 Broad Street",
					"Regina",
					"SK",
					"S4R 1X4",
				],
				"map9": [
					"133 Main Street",
					"Rouleau",
					"SK",
					"S0G 4H0",
				],
				"map8": [
					"200 Mergens Street",
					"Pangman",
					"SK",
					"S0C 2C0",
				],
			},
			phone: "1-306-757-1633",
			menuPhone: "button",
			ab: "a",
			logo: "a.png",
			brand_name: "hwi.link.wawanesalife.com",
		},
		b: {
			environment: "stable",
			broker: "hwi",
			website: "https://harvardwestern.com/",
			broker_formatted_name: "Harvard Western Insurance",
			privacyLink: "https://harvardwestern.com/privacy-policy/",
			faq_text: "Frequently Asked Questions",
			layout: "modern",
			scope: "hwi#branding#hwi.link.wawanesalife.com#b",
			approve_company: "Link Platform",
			email: "info@harvardwestern.com",
			render_fake_email_button: "yes",
			g4: "GTM-P6HT43K",
			approve_user: "link_hwi",
			logoPosition: "menu",
			environment_id: "stable",
			brands: [
				"hwi.link.wawanesalife.com",
			],
			"maps": {
				"map3": [
					"4420 Albert Street",
					"Regina",
					"SK",
					"S4S 6B4",
				],
				"map2": [
					"464 McCarthy Blvd. N.",
					"Regina",
					"SK",
					"S4R 7M2",
				],
				"map1": [
					"3615 Quance Street East",
					"Regina",
					"SK",
					"S4V 3A4",
				],
				"map10": [
					"115 3rd St",
					"Dalmeny",
					"SK",
					"S0K 1E0",
				],
				"map7": [
					"109 Souris Street",
					"Yellow Grass",
					"SK",
					"S0G 5J0",
				],
				"map6": [
					"128 Main Street",
					"Milestone",
					"SK",
					"S0G 3L0",
				],
				"map5": [
					"5 Main Street",
					"Kronau",
					"SK",
					"S0G 2T0",
				],
				"map4": [
					"407 Broad Street",
					"Regina",
					"SK",
					"S4R 1X4",
				],
				"map9": [
					"133 Main Street",
					"Rouleau",
					"SK",
					"S0G 4H0",
				],
				"map8": [
					"200 Mergens Street",
					"Pangman",
					"SK",
					"S0C 2C0",
				],
			},
			phone: "1-306-757-1633",
			menuPhone: "button",
			ab: "b",
			logo: "b.png",
			brand_name: "hwi.link.wawanesalife.com",
		},
	},
};

//updated on Wed Jun 18 2025 23:18:05 GMT+0000 (Coordinated Universal Time)
